<template>
  <div class="diagnosis-card">
    <span class="dev-annotation calculated">Your Logic</span>

    <div class="diagnosis-header">
      <div class="diagnosis-title">
        <div class="icon-wrap">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="11" cy="11" r="8"></circle><path d="M21 21l-4.35-4.35"></path>
          </svg>
        </div>
        Diagnosis
      </div>
      <span class="live-badge">Live Data</span>
    </div>

    <div class="diagnosis-content">
      <div class="diagnosis-headline">
        <h3>{{ diagnosis.primaryCause }}</h3>
        <span class="confidence-badge">• {{ confidenceLabel }}</span>
      </div>
      <p class="diagnosis-text">{{ diagnosis.description }}</p>
    </div>

    <div class="dev-notes">
      <div class="dev-notes-title">Developer Notes — Diagnosis Logic</div>
      <ul>
        <li><strong>High Confidence:</strong> Price gap &gt; 5% AND both FBA (or both FBM)</li>
        <li><strong>Medium Confidence:</strong> Price gap &lt; 5% OR mixed fulfillment</li>
        <li><strong>Low Confidence:</strong> Price is competitive, non-price factor suspected</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiagnosisPanel',
  props: {
    diagnosis: {
      type: Object,
      required: true
    }
  },
  computed: {
    confidenceLabel() {
      const c = (this.diagnosis.confidence || 'medium').toLowerCase()
      if (c === 'high') return 'High Confidence'
      if (c === 'low') return 'Low Confidence'
      return 'Medium Confidence'
    }
  }
}
</script>




// WEBPACK FOOTER //
// DiagnosisPanel.vue?35a7b727